export default __webpack_public_path__ + "static/media/github.0133fe9c.svg";